import { render, staticRenderFns } from "./study-participant-form.vue?vue&type=template&id=b12d589c&scoped=true&"
import script from "./study-participant-form.vue?vue&type=script&lang=js&"
export * from "./study-participant-form.vue?vue&type=script&lang=js&"
import style0 from "./study-participant-form.vue?vue&type=style&index=0&id=b12d589c&scoped=true&lang=scss&"
import style1 from "./study-participant-form.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b12d589c",
  null
  
)

component.options.__file = "study-participant-form.vue"
export default component.exports